import React, { useMemo, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { ImagePickerContainer } from '@bingads-webui-react/image-picker';
import { LoadingPlaceholder } from '@bingads-webui-campaign-react/image-experience';
import getInvestVideoItemWrapper from './invest-video-wrapper';
import { getVideoObjectForImagePickerFromMTObject } from '../../util/video-converter';

const itemHeight = 180;
const getPickerHeight = () => {
  if (window.innerHeight > 1000) {
    return 580;
  } else if (window.innerHeight > 870) {
    return 450;
  }
  return 350;
};

const loadingPlaceholder = () => (<LoadingPlaceholder />);

const InvestVideoPickerContainer = (props) => {
  const {
    i18n,
    investVideoDataSource,
    videoRepository,
    onVideoSelected,
    showUiBlocker,
    showErrors,
    isLazyLoadEnabled,
    videoPickerContainerHeight,
  } = props;

  const onInvestVideoSelected = useCallback((selectedItems) => {
    showUiBlocker(true);
    showErrors([]);

    const item = selectedItems[0];
    investVideoDataSource.saveVideoAsync({
      Url: item.videoSrc,
      XandrAssetId: item.id,
      Description: item.altText,
    })
      .then(({ value }) => videoRepository.getVideo({ id: value }))
      .then(videoFromMT => getVideoObjectForImagePickerFromMTObject(videoFromMT))
      .then(video => onVideoSelected({ ...video, src: video.videoSrc }))
      .finally(() => showUiBlocker(false))
      .catch(() => showErrors([i18n.getString('ImageExperience_InvestVideoUploadFail')]));
  }, [i18n, investVideoDataSource, onVideoSelected, showErrors, showUiBlocker, videoRepository]);

  const investVideoItemWrapper = useMemo(() => getInvestVideoItemWrapper({
    i18n,
    investVideoDataSource,
    showUiBlocker,
    onInvestVideoSelected,
  }), [
    i18n,
    showUiBlocker,
    investVideoDataSource,
    onInvestVideoSelected,
  ]);

  const onLoadMore = useCallback(() => {
    investVideoDataSource.loadMore();
  }, [investVideoDataSource]);

  return (
    <div className="user-image-picker-container">
      <ImagePickerContainer
        i18n={i18n}
        dataSource={investVideoDataSource}
        isMultiSelection={false}
        onSelectionChanged={onInvestVideoSelected}
        isLazyLoadEnabled={isLazyLoadEnabled}
        onLoadMore={onLoadMore}
        isAutoLoadMore
        height={videoPickerContainerHeight || getPickerHeight()}
        itemHeight={itemHeight}
        imageListItemWrapper={investVideoItemWrapper}
        imagePlaceHolder={loadingPlaceholder}
        useBingAdsLoader
      />
    </div>
  );
};

InvestVideoPickerContainer.propTypes = {
  investVideoDataSource: PropTypes.shape({
    reload: PropTypes.func.isRequired,
    loadMore: PropTypes.func.isRequired,
    searchAsync: PropTypes.func.isRequired,
    saveVideoAsync: PropTypes.func.isRequired,
  }).isRequired,
  videoRepository: PropTypes.shape({
    getVideo: PropTypes.func.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  permissions: PropTypes.shape({}),
  onVideoSelected: PropTypes.func.isRequired,
  showErrors: PropTypes.func,
  showUiBlocker: PropTypes.func,
  isLazyLoadEnabled: PropTypes.bool.isRequired,
  videoPickerContainerHeight: PropTypes.number,
};

InvestVideoPickerContainer.defaultProps = {
  showErrors: _.noop,
  showUiBlocker: _.noop,
  permissions: {},
  videoPickerContainerHeight: null,
};

export default InvestVideoPickerContainer;
